import React from 'react';
import T from './modules/translation';

function Ponder(props) {
  return (
    <div className="ponderCheckBox form-check form-check-inline">
      <input className="form-check-input" type="checkbox" 
        id="ponder" name="ponder"
        onChange={props.onChange}
        defaultChecked={true} />
      <label className="checkbox-inline">
        {T.get("ponder")}<span>(n/s): {props.speed ? props.speed : ''}</span>
      </label>
    </div>
  );
}

export default Ponder;